module.exports = __webpack_public_path__ + "img/764.5bb4ff2a.png";